export const toUnderScore = (text) => {
  return text.replace(/\s+/g, '_');
}
